// svg element close icon for tooltip
export const closeIcon = `<svg id="close-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.71313 3L3.00699 3.7049L6.79636 7.497L3 11.2941L3.70714 12L7.5025 8.20391L11.2939 11.996L12 11.2901L8.20863 7.497L11.994 3.71089L11.2869 3.00499L7.5025 6.7901L3.71313 3Z"
                    fill="var(--vscode-icon-foreground)"
                />
            </g>
        </svg>`;
